import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { ClearButton, SubmitButton } from "./styles";

import { KIDS_OFFSET, PUPS_OFFSET } from "./config";

const OuterContainer = styled.div`
  position: fixed;
  top: 50px;
  padding: 4px;
  z-index: 3;
  width: calc(100% - 80px);
  left: 33px;
  border: 3px solid #e04778;
  border-radius: 20px;
  background-color: #fff;

  @media only screen and (min-width: 975px) {
    top: 140px;
    width: 600px;
    left: calc(50% - 300px);
  }
`;

const Container = styled.div`
  background-color: #f2a7bf;
  border-radius: 16px;
  color: #fff;
  padding: 20px;
  width: calc(100% - 40px);

  @media only screen and (min-width: 975px) {
    padding: 40px;
    width: calc(100% - 80px);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 975px) {
    justify-content: end;
  }
`;

const CloseButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 40px;
  border-radius: 50px;
  height: 27px;
  width: 27px;
  cursor: pointer;

  &:hover {
    background-color: rgb(255, 216, 229);

    & div {
      color: #e04778;
    }
  }
`;

const CloseButton = styled.div`
  color: #fff;
  font-size: 26px;
  align-self: start;
  margin-top: -2.5px;
  margin-left: 6px;
`;

const Heading = styled.h1`
  font-size: 32px;
  text-align: center;
  color: #fff;
  margin-top: 0;
  margin-bottom: 12px;
`;

const InnerContainer = styled.div`
  background-color: rgb(255, 216, 229);
  margin: 0 auto;
  border-radius: 12px;
  border: none;
  padding: 20px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 26px;
  color: #666;
  max-height: 320px;
  overflow-y: scroll;

  div:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const List = styled.ul`
  margin-left: 18px;
`;

const ListItem = styled.li``;

const ConfirmationModal = ({
  closeModal,
  handleSubmit,
  kidsStagedForDeposit,
  pupsStagedForDeposit,
  kidsStagedForWithdrawal,
  pupsStagedForWithdrawal,
}) => {
  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      const shouldClose = ![
        "confirmation-modal",
        "confirmation-container",
        "confirmation-heading",
        "confirmation-inner-container",
        "confirmation-modal-list",
        "confirmation-modal-list-item",
        "confirmation-modal-list-withdrawal",
        "confirmation-modal-list-item-withdrawal",
        "confirmation-modal-btns-container",
        "submit-button",
      ].includes(event.target.id);
      if (shouldClose) {
        closeModal();
      }
    },
    [closeModal]
  );

  useEffect(() => {
    const body = document.querySelector("body");
    body.addEventListener("click", handleClick);
    return () => {
      body.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  useEffect(() => {
    if (
      [
        ...kidsStagedForDeposit,
        ...pupsStagedForDeposit,
        ...kidsStagedForWithdrawal,
        ...pupsStagedForWithdrawal,
      ].length === 0
    ) {
      closeModal();
    }
  }, [
    closeModal,
    kidsStagedForDeposit,
    pupsStagedForDeposit,
    kidsStagedForWithdrawal,
    pupsStagedForWithdrawal,
  ]);

  return (
    <OuterContainer id="confirmation-modal">
      <Container id="confirmation-container">
        <CloseButtonContainer onClick={closeModal}>
          <CloseButton>×</CloseButton>
        </CloseButtonContainer>
        <Heading id="confirmation-heading">Nice!</Heading>
        <InnerContainer id="confirmation-inner-container">
          {[...kidsStagedForDeposit, ...pupsStagedForDeposit].length > 0 ? (
            <>
              These campers are ready to head off to camp:
              <List id="confirmation-modal-list">
                {kidsStagedForDeposit.map((id) => (
                  <ListItem
                    key={`kid-deposit-${id}`}
                    id="confirmation-modal-list-item"
                  >
                    Kid #{(id + KIDS_OFFSET) % 10_000}
                  </ListItem>
                ))}
                {pupsStagedForDeposit.map((id) => (
                  <ListItem
                    key={`pup-deposit-${id}`}
                    id="confirmation-modal-list-item"
                  >
                    Puppy #{(id + PUPS_OFFSET) % 10_000}
                  </ListItem>
                ))}
              </List>
            </>
          ) : (
            ""
          )}
          {[...kidsStagedForWithdrawal, ...pupsStagedForWithdrawal].length >
          0 ? (
            <>
              These campers are ready to come back home:
              <List id="confirmation-modal-list-withdrawal">
                {kidsStagedForWithdrawal.map((id) => (
                  <ListItem
                    key={`kid-withdrawal-${id}`}
                    id="confirmation-modal-list-item-withdrawal"
                  >
                    Kid #{(id + KIDS_OFFSET) % 10_000}
                  </ListItem>
                ))}
                {pupsStagedForWithdrawal.map((id) => (
                  <ListItem
                    key={`pup-withdrawal-${id}`}
                    id="confirmation-modal-list-item-withdrawal"
                  >
                    Puppy #{(id + PUPS_OFFSET) % 10_000}
                  </ListItem>
                ))}
              </List>
            </>
          ) : (
            ""
          )}
          If that looks good, hit submit! Or you can make more changes first
        </InnerContainer>
        <ButtonsContainer id="confirmation-modal-btns-container">
          <ClearButton onClick={closeModal}>Make Changes</ClearButton>
          <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
        </ButtonsContainer>
      </Container>
    </OuterContainer>
  );
};

export default ConfirmationModal;
